import { FilterField, filtersBoxBuild } from 'components/Common/Table'


export default filtersBoxBuild([
    new FilterField('name__icontains', '', 'Name'),
    new FilterField('country__icontains', '', 'Country'),
    new FilterField('phone_number__icontains', '', 'Phone'),
    new FilterField('zip_code__icontains', '', 'Zip Code'),
])